import React, { useEffect } from 'react';
// import { CardQuestion } from '../../components';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  QUESTION_NEW_PATH,
  QUESTION_PATH,
} from '../../routes/path';
import { getQuestion } from '../../redux/actions/questionActions';
import { CardQuestion, Loading } from '../../components';

const Question = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading, questions } = useSelector((state) => state.questionReducer);

  const redirect = () => {
    navigate(`${QUESTION_PATH}${QUESTION_NEW_PATH}`);
  };

  useEffect(() => {
    dispatch(getQuestion());
  }, []);

  if (isLoading) return <Loading />;

  return (
    <div className="question-container">
      <div className="items-container">
        <h4>Preguntas</h4>
        <button className="buttonQuestion-turn-confirm" onClick={redirect}>Nueva pregunta</button>
      </div>
      <div className="cardsquestion-container">
        {questions?.length === 0 ? 'No hay preguntas disponibles para mostrar'
          : questions?.map((question) => (
            <CardQuestion question={question} key={question.id} />
          ))}
      </div>
    </div>
  );
};

export default Question;
